import { render, staticRenderFns } from "./attachmentDialog.vue?vue&type=template&id=ca97c588&lang=pug"
import script from "./attachmentDialog.vue?vue&type=script&lang=js"
export * from "./attachmentDialog.vue?vue&type=script&lang=js"
import style0 from "./attachmentDialog.vue?vue&type=style&index=0&id=ca97c588&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports